import { useFetch, usePromise } from '@rad/hooks';
import { useAuth } from './useAuth';
import { useCommunity } from './useDistrict';
import { myCommunities } from '../common/network/community';
import { adminUrls, adminUrlsArray } from '../common/routes/urls/admin';
import { onSubdomain } from '../common/routes/urls/general';
import { getCommunityURL, hasAnyAdminPermission } from '../common/routes/_';
const ROOT_LABEL = '76Unboxed';
// The kinds in the order the menu lists them, each with the icon that tells it apart
const KINDS = [
    { kind: 'root', icon: 'bi-globe-americas', label: ROOT_LABEL },
    { kind: 'district', icon: 'bi-bank', label: 'Districts' },
    { kind: 'organization', icon: 'bi-briefcase', label: 'Organizations' },
];
/** One entry per kind with any links: the link itself when it's the only one of its kind, else a group. */
const groupManageLinks = (links) => KINDS.flatMap(({ kind, icon, label }) => {
    const ofKind = links.filter(l => l.kind === kind);
    return ofKind.length === 0 ? []
        : ofKind.length === 1 ? [{ type: 'link', kind, icon, link: ofKind[0] }]
            : [{ type: 'group', kind, icon, label, links: ofKind }];
});
/**
 * Links to the admin area of every community the signed-in user can manage, grouped by kind: within
 * a kind, the one they're on first, then the rest. The one they're on is judged by their session,
 * as its admin area is; the rest by the permissions the server reports for each, the root's being
 * the platform-wide grants. Call only once the user is signed in.
 */
export const useManageLinks = () => {
    var _a;
    const [auth] = useAuth();
    const { district } = useCommunity();
    const [communitiesPromise] = useFetch(myCommunities);
    const communities = (_a = usePromise(communitiesPromise)) !== null && _a !== void 0 ? _a : [];
    const current = onSubdomain && hasAnyAdminPermission([adminUrlsArray], auth.hasPermission)
        ? [{ key: district.id, kind: district.kind, label: district.title, href: adminUrls.manage.getURL() }]
        : [];
    const others = communities
        .filter(c => !(onSubdomain && c.id === district.id))
        .filter(c => hasAnyAdminPermission([adminUrlsArray], (perms) => perms.some(p => c.permissions.includes(p))))
        .map(c => ({
        key: c.id,
        kind: c.kind,
        label: c.kind === 'root' ? ROOT_LABEL : c.title,
        href: getCommunityURL(c, adminUrls.manage.getURL()),
    }));
    return groupManageLinks([...current, ...others]);
};
